angular.module('cerberus.les')
    .controller('LESLoanApplicationEligibilityCtrl', function(_, $scope, $rootScope, $location, $timeout, $q, loanApplicationId, lesLoanApplicationsService, OdataUtilityService){
        var vm = this;

        vm.loanApplicationId = loanApplicationId;
        vm.loanApplication = {};
        vm.mainBorrower = '';
        vm.lenders = [];
        vm.creditScores = [];
        vm.docTypes = [];
        vm.amortizationTypes = [];
        vm.loadingProducts = false;
        vm.notFound = false;
        vm.productSelected = false;
        vm.tabActive = {};
        vm.breadcrumbDisplay = 'Loading...';
        vm.eligibilityError = '';
        vm.eligibilityType = '';
        vm.eligibilityTypeCounts = {
            all: 0,
            eligible: 0,
            ineligible: 0,
            nearmiss: 0
        };
        vm.termsFilter = {
            field: 'loanAmortizationType',
            operator: 'eq',
            value: ''
        };
        vm.doctypeFilter = {
            field: 'docType',
            operator: 'eq',
            value: ''
        };
        vm.rateFilter = {
            field: 'rate',
            operator: 'lte',
            value: ''
        };
        vm.rateFilterOptions = {
            step: 0.25,
            format: 'n2',
            min: 0,
            decimals: 2
        };

        vm.productRateDetailTableOptions = lesLoanApplicationsService.productRateDetailTableOptions;
        vm.operatorSymbols = OdataUtilityService.operatorSymbols();
        vm.operators = OdataUtilityService.operators();

        vm.updateEligibilityFilter = updateEligibilityFilter;        
        vm.applyFilters = applyFilters;
        vm.clearFilter = clearFilter;
        vm.refineSearch = refineSearch;
        vm.navToLoanPage = navToLoanPage;

        var instanceWindowCallback = {};

        init();

        function init(){
            vm.loanApplication = {};
            vm.mainBorrower = '';
            vm.lenders = [];
            vm.creditScores = [];
            vm.docTypes = [];
            vm.amortizationTypes = [];
            vm.tabActive = {};
            vm.eligibilityError = '';
            vm.eligibilityType = '';
            vm.eligibilityTypeCounts = {
                all: 0,
                eligible: 0,
                ineligible: 0,
                nearmiss: 0
            };
            vm.termsFilter = {
                field: 'loanAmortizationType',
                operator: 'eq',
                value: ''
            };
            vm.doctypeFilter = {
                field: 'docType',
                operator: 'eq',
                value: ''
            };
            vm.rateFilter = {
                field: 'rate',
                operator: 'lte',
                value: ''
            };
            vm.loadingProducts = true;

            lesLoanApplicationsService.getLoanApplication(loanApplicationId).then(function(loanApplication){
                if(loanApplication.recordData.findings){
                    vm.loanApplication = loanApplication.recordData.loanApp;
                    vm.productSelected = true;
                    vm.loadingProducts = false;
                }
                else{
                    vm.loanApplication = loanApplication.recordData;
                }

                var loanRecordId = _.last(loanApplicationId.split('-')),
                    mainBorrowerName = _.get(vm.loanApplication, 'mainBorrower.fullName'),
                    mainBorrowerId = _.get(vm.loanApplication, 'mainBorrower.id');

                instanceWindowCallback.callback = function () { $rootScope.$broadcast('nim-loan-update', loanApplicationId); };
                
                vm.mainBorrower = mainBorrowerName;
                vm.breadcrumbDisplay = mainBorrowerName + ' (#' + loanRecordId + ')';

                vm.openApplicationRecord = _.partial(lesLoanApplicationsService.openApplicationRecord, loanRecordId, false, instanceWindowCallback);

                if (vm.productSelected) {
                    return;
                }

                if (_.isEmpty($location.search())) {
                    setDefaultQueryParams();
                }
                
                lesLoanApplicationsService.getLoanPrograms(loanApplicationId).then(function (programData) {
                    vm.lenders = programData.lenders;

                    var eligibilityPromises = [];
                    
                    _.forEach(vm.lenders, function (l) {
                        _.forEach(l.programs, function (p) {
                            var prom = lesLoanApplicationsService.getLoanProgramEligibility(loanApplicationId, p.id, l.conduit, $location.search()).then(function (eligibilityData) {
                                _.assign(p, eligibilityData);

                                return true;
                            }, function (err) {
                                vm.eligibilityError = err;

                                return true;
                            });

                            eligibilityPromises.push(prom);
                        });
                    });

                    $q.all(eligibilityPromises).then(function () {
                        vm.productEligibilityTableOptions = lesLoanApplicationsService.productEligibilityTableOptions(vm.eligibilityType, vm.lenders);
                        // setEligibilityClickHandler();

                        var eligibilityTypeCounts = _.countBy(vm.productEligibilityTableOptions.dataSource.data, 'eligibility');

                        if (eligibilityTypeCounts.eligible) {
                            vm.tabActive['eligible'] = true;
                            vm.eligibilityType = 'eligible';
                            vm.productEligibilityTableOptions.dataSource.filter.filters.push({
                                field: 'eligibility',
                                operator: 'eq',
                                value: 'eligible'
                            });
                        }
                        else {
                            vm.tabActive['all'] = true;
                        }

                        eligibilityTypeCounts.all = vm.productEligibilityTableOptions.dataSource.data.length;
                        _.assign(vm.eligibilityTypeCounts, eligibilityTypeCounts);

                        var filterData = lesLoanApplicationsService.getFilterOptions(vm.lenders);
                        
                        vm.amortizationTypes = filterData.amortizationTypes;
                        vm.termsLookupOptions = lesLoanApplicationsService.eligibilityFilterLookupOptions(filterData.amortizationTypes);
                        
                        vm.docTypes = filterData.docTypes;
                        vm.docTypeLookupOptions = lesLoanApplicationsService.eligibilityFilterLookupOptions(filterData.docTypes);

                        vm.loadingProducts = false;

                        if (eligibilityTypeCounts.all === 0) {
                            vm.eligibilityError = 'No products found. Please refine your search.';
                        }
                    }, function () {
                        vm.loadingProducts = false;
                        vm.productEligibilityTableOptions = lesLoanApplicationsService.productEligibilityTableOptions(vm.eligibilityType, []);
                    });
                }, function () {
                    vm.loadingProducts = false;
                    vm.productEligibilityTableOptions = lesLoanApplicationsService.productEligibilityTableOptions(vm.eligibilityType, []);
                });

                if (mainBorrowerId) {
                    lesLoanApplicationsService.getCreditData(loanRecordId).then(function (data) {
                        /* LODASH Version 4 ONLY */
                        //vm.creditScores = _.filter(data.scores, ['borrowerId', mainBorrowerId]);
                        /* LODASH Version 3 & 4 Compatibility Mode */
                        vm.creditScores = _.filter(data.scores, function(c){return c.borrowerId === mainBorrowerId;});
                    });
                }
            }, function (reason) {
                if (reason == "Not Found.") {
                    vm.loadingProducts = false;
                    vm.notFound = true;
                }
            });
        }

        function setDefaultQueryParams() {
            var docTypes = [];

            if (vm.loanApplication.isSelfEmployed) {
                docTypes.push('12M Bank Statements');
                docTypes.push('24M Bank Statements');
                }
            // else {
                docTypes.push('Full Document'); // Now unconditional
            // }
            var baseLoanAmount = vm.loanApplication.BaseLoanAmount || 0;
            var totalAssets = vm.loanApplication.totalAssets || 0;

            if ((totalAssets * 2) >= baseLoanAmount) {
                docTypes.push('Asset Utilization');
            }

            if (vm.loanApplication.PropertyUsagetype.display == 'Investor') {
                docTypes.push('Debt Service Coverage');
            }

            $location.replace().search({
                amortizations: 'arm,fixed',
                ppp: 'no',
                docTypes: docTypes.join(',')
            });
        }

        function updateEligibilityFilter(eligibilityType) {
            if (eligibilityType != vm.eligibilityType) {
                vm.eligibilityType = eligibilityType;
                applyFilters();
            }
        }

        function applyFilters() {
            var filter = {
                logic: 'and',
                filters: []
            };

            if (vm.eligibilityType) {
                filter.filters.push({
                    field: 'eligibility',
                    operator: 'eq',
                    value: vm.eligibilityType
                });
            }

            if (vm.termsFilter.value && vm.termsFilter.value !== 'Choose...') {
                filter.filters.push(vm.termsFilter);
            }

            // if (vm.doctypeFilter.value && vm.doctypeFilter.value !== 'Choose...') {
            //     filter.filters.push(vm.doctypeFilter);
            // }

            if (vm.rateFilter.value || vm.rateFilter.value === 0) {
                filter.filters.push(vm.rateFilter);
            }

            $timeout(function () {
                if (vm.productEligibilityTable) {
                    vm.productEligibilityTable.dataSource.filter(filter);
                }
            });
        }

        function clearFilter(filter) {
            filter.value = '';
            applyFilters();
        }

        function refineSearch() {
            var defaultQueryParams = lesLoanApplicationsService.parseProductsQueryParams($location.search());
            lesLoanApplicationsService.openFindProductsModal(defaultQueryParams).then(function (result) {
                $location.replace().search(result);
            });
        }

        function navToLoanPage() {
            $location.url('D4FEB549FFBA0E36B19E7D9579BD4791-2');
        }

        // function setEligibilityClickHandler() {
        //     $scope.$on('kendoWidgetCreated', function (e, kWidget) {
        //         e.preventDefault();
        //         console.log(kWidget);

        //         if (kWidget == vm.productEligibilityTable) {
        //             var openRows = {};
                    
        //             kWidget.tbody.on('click', '.k-master-row', function (event) {
        //                 event.preventDefault();
        //                 event.stopPropagation();
        //                 event.stopImmediatePropagation();
        //                 var uid = angular.element(event.currentTarget).data('uid');

        //                 console.log(uid);
        //                 if (openRows[uid]) {
        //                     kWidget.collapseRow(event.currentTarget);
        //                     openRows[uid] = false;
        //                 }
        //                 else {
        //                     kWidget.expandRow(event.currentTarget);
        //                     openRows[uid] = true;
        //                 }
        //             });
        //         }
        //     });
        // }

        $scope.$on('nim-loan-update', function (e, id) {
            e.preventDefault();

            if (id == loanApplicationId) {
                init();
            }
        });

        $scope.$on('$locationChangeStart', function (e, newUrl) {
            newUrl = newUrl || '';
            
            var path = '/loan-applications/' + loanApplicationId + '/eligibility';
            if (newUrl.indexOf(path) < 0 && !e.defaultPrevented) {
                if (vm.productEligibilityTable) {
                    vm.productEligibilityTable.destroy();
                    vm.productEligibilityTable = null;
                }
                
                if (vm.termsLookup) {
                    vm.termsLookup.destroy();
                    vm.termsLookup = null;
                }
            }
        });
    })
;